import type { ContentPerilakuKerja } from 'types/kinerja'

export const CONTENT_PERILAKU_KERJA: ContentPerilakuKerja = {
  aspek: [
    {
      id: 1,
      orderAspek: 1,
      value: 'Berorientasi Pelayanan',
      indikator: [
        {
          id: 1,
          orderIndikator: 1,
          value: 'Memahami kebutuhan satuan pendidikan',
          ekspektasi: [
            {
              id: 1,
              orderEkspektasi: 1,
              value:
                'Mengidentifikasi kebutuhan satuan pendidikan secara proaktif',
            },
            {
              id: 2,
              orderEkspektasi: 2,
              value: 'Memenuhi kebutuhan satuan pendidikan secara responsif',
            },
            {
              id: 3,
              orderEkspektasi: 3,
              value:
                'Melayani satuan pendidikan sesuai aspirasi dan/atau keluhan yang diterima',
            },
            {
              id: 4,
              orderEkspektasi: 4,
              value:
                'Menyelesaikan keluhan satuan pendidikan dengan komunikasi persuasif',
            },
          ],
        },
        {
          id: 2,
          orderIndikator: 2,
          value: 'Ramah, cekatan dalam bekerja, dan dapat diandalkan',
          ekspektasi: [
            {
              id: 5,
              orderEkspektasi: 1,
              value: 'Menuntaskan semua pekerjaan',
            },
            {
              id: 6,
              orderEkspektasi: 2,
              value: 'Mengucapkan salam dan sapa dengan sikap ramah',
            },
            {
              id: 7,
              orderEkspektasi: 3,
              value: 'Mengomunikasikan informasi secara aktual dan akurat',
            },
            {
              id: 8,
              orderEkspektasi: 4,
              value: 'Melayani dengan standar dan kualitas yang sama',
            },
          ],
        },
        {
          id: 3,
          orderIndikator: 3,
          value:
            'Melakukan perbaikan kompetensi dan perilaku secara terus-menerus',
          ekspektasi: [
            {
              id: 9,
              orderEkspektasi: 1,
              value: 'Memperbaiki kualitas layanan secara terus-menerus',
            },
            {
              id: 10,
              orderEkspektasi: 2,
              value:
                'Menindaklanjuti setiap kritik dan saran secara konstruktif',
            },
            {
              id: 11,
              orderEkspektasi: 3,
              value: 'Berupaya memperluas wawasan kualitas pelayanan',
            },
          ],
        },
      ],
    },
    {
      id: 2,
      orderAspek: 2,
      value: 'Akuntabel',
      indikator: [
        {
          id: 4,
          orderIndikator: 1,
          value:
            'Melaksanakan tugas dengan jujur, bertanggung jawab, cermat, disiplin, dan berintegritas tinggi',
          ekspektasi: [
            {
              id: 12,
              orderEkspektasi: 1,
              value: 'Memenuhi janji dan komitmen pekerjaan',
            },
            {
              id: 13,
              orderEkspektasi: 2,
              value: 'Melaksanakan pekerjaan sesuai dengan ketentuan',
            },
            {
              id: 14,
              orderEkspektasi: 3,
              value:
                'Bertanggung jawab atas hasil kerja yang dilakukan dan bersedia dievaluasi',
            },
            {
              id: 15,
              orderEkspektasi: 4,
              value:
                'Menolak segala bentuk gratifikasi, korupsi, kolusi, dan nepotisme',
            },
          ],
        },
        {
          id: 5,
          orderIndikator: 2,
          value:
            'Memanfaatkan sumber daya secara bertanggung jawab, efektif, dan efisien',
          ekspektasi: [
            {
              id: 16,
              orderEkspektasi: 1,
              value: 'Menggunakan fasilitas kerja sesuai dengan peruntukannya',
            },
            {
              id: 17,
              orderEkspektasi: 2,
              value:
                'Mendorong efisiensi penggunaan sarana dan prasarana satuan pendidikan',
            },
          ],
        },
        {
          id: 6,
          orderIndikator: 3,
          value:
            'Tidak menyalahgunakan kewenangan jabatan demi keuntungan pribadi',
          ekspektasi: [
            {
              id: 18,
              orderEkspektasi: 1,
              value:
                'Menghindari situasi yang menimbulkan konflik kepentingan pribadi',
            },
            {
              id: 19,
              orderEkspektasi: 2,
              value:
                'Mengambil keputusan dengan objektif saat terjadi konflik kepentingan',
            },
          ],
        },
      ],
    },
    {
      id: 3,
      orderAspek: 3,
      value: 'Kompeten',
      indikator: [
        {
          id: 7,
          orderIndikator: 1,
          value:
            'Melaksanakan peningkatan kompetensi sesuai kebutuhan satuan pendidikan',
          ekspektasi: [
            {
              id: 20,
              orderEkspektasi: 1,
              value:
                'Meningkatkan kapasitas dan kompetensi diri secara terus-menerus',
            },
            {
              id: 21,
              orderEkspektasi: 2,
              value:
                'Berdiskusi dengan atasan dan rekan sejawat untuk mencari solusi',
            },
          ],
        },
        {
          id: 8,
          orderIndikator: 2,
          value: 'Membantu pemangku satuan pendidikan untuk saling belajar',
          ekspektasi: [
            {
              id: 22,
              orderEkspektasi: 1,
              value:
                'Memberikan kesempatan bagi kepala sekolah untuk menyampaikan pendapat',
            },
            {
              id: 23,
              orderEkspektasi: 2,
              value:
                'Membagikan pengetahuan dan pengalaman melalui dialog bersama kepala sekolah, guru, tenaga kependidikan, orang tua, dan masyarakat atau dunia kerja',
            },
          ],
        },
        {
          id: 9,
          orderIndikator: 3,
          value: 'Melaksanakan tugas dengan kualitas terbaik',
          ekspektasi: [
            {
              id: 24,
              orderEkspektasi: 1,
              value:
                'Menyusun rencana kerja secara kontekstual dan partisipatif',
            },
            {
              id: 25,
              orderEkspektasi: 2,
              value: 'Melaksanakan rencana kerja sesuai target yang ditetapkan',
            },
            {
              id: 26,
              orderEkspektasi: 3,
              value: 'Menyelesaikan masalah secara komprehensif dan tuntas',
            },
          ],
        },
      ],
    },
    {
      id: 4,
      orderAspek: 4,
      value: 'Harmonis',
      indikator: [
        {
          id: 10,
          orderIndikator: 1,
          value: 'Menghargai seluruh pemangku pendidikan',
          ekspektasi: [
            {
              id: 27,
              orderEkspektasi: 1,
              value: 'Berlaku adil kepada semua pihak tanpa memandang status',
            },
            {
              id: 28,
              orderEkspektasi: 2,
              value:
                'Menjaga hubungan baik dengan satuan pendidikan dan masyarakat',
            },
            {
              id: 29,
              orderEkspektasi: 3,
              value:
                'Menghormati gagasan yang disampaikan satuan pendidikan dan masyarakat',
            },
          ],
        },
        {
          id: 11,
          orderIndikator: 2,
          value: 'Memberikan bantuan bagi satuan pendidikan',
          ekspektasi: [
            {
              id: 30,
              orderEkspektasi: 1,
              value: 'Menawarkan solusi kepada kepala sekolah dengan responsif',
            },
            {
              id: 31,
              orderEkspektasi: 2,
              value:
                'Memberikan solusi dan/atau informasi kepada kepala sekolah sesuai kewenangan',
            },
          ],
        },
        {
          id: 12,
          orderIndikator: 3,
          value: 'Membangun lingkungan yang kondusif',
          ekspektasi: [
            {
              id: 32,
              orderEkspektasi: 1,
              value: 'Menyelesaikan konflik secara konstruktif',
            },
            {
              id: 33,
              orderEkspektasi: 2,
              value:
                'Berinteraksi dengan berbagai pihak berdasarkan etika yang tinggi',
            },
            {
              id: 34,
              orderEkspektasi: 3,
              value:
                'Menghindari interaksi yang berpotensi menimbulkan konflik',
            },
          ],
        },
      ],
    },
    {
      id: 5,
      orderAspek: 5,
      value: 'Loyal',
      indikator: [
        {
          id: 13,
          orderIndikator: 1,
          value:
            'Memegang teguh moral dan mematuhi peraturan perundang-undangan yang berlaku',
          ekspektasi: [
            {
              id: 35,
              orderEkspektasi: 1,
              value:
                'Menghindari ucapan dan perbuatan yang menjurus pada perpecahan',
            },
            {
              id: 36,
              orderEkspektasi: 2,
              value:
                'Menyebarkan informasi yang mendukung transformasi pendidikan',
            },
            {
              id: 37,
              orderEkspektasi: 3,
              value:
                'Mencegah situasi yang menghambat transforrmasi satuan pendidikan',
            },
          ],
        },
        {
          id: 14,
          orderIndikator: 2,
          value: 'Menjaga nama baik dinas pendidikan dimanapun berada',
          ekspektasi: [
            {
              id: 38,
              orderEkspektasi: 1,
              value:
                'Bersikap dan berperilaku yang mencerminkan citra dinas pendidikan',
            },
            {
              id: 39,
              orderEkspektasi: 2,
              value:
                'Melaksanakan arahan dinas pendidikan yang sesuai dengan norma dan ketentuan yang berlaku',
            },
            {
              id: 40,
              orderEkspektasi: 3,
              value:
                'Menyebarkan informasi positif dari dinas pendidikan tentang transformasi pendidikan',
            },
          ],
        },
        {
          id: 15,
          orderIndikator: 3,
          value:
            'Menjaga informasi yang bersifat sensitif dan berpotensi merugikan dinas pendidikan dan satuan pendidikan',
          ekspektasi: [
            {
              id: 41,
              orderEkspektasi: 1,
              value:
                'Menyimpan informasi sensitif dengan cara dan pada tempat yang aman',
            },
            {
              id: 42,
              orderEkspektasi: 2,
              value:
                'Membagikan informasi sensitif hanya kepada pihak yang berwenang',
            },
            {
              id: 43,
              orderEkspektasi: 3,
              value:
                'Mencegah situasi yang mengancam kelangsungan transformasi pendidikan',
            },
          ],
        },
      ],
    },
    {
      id: 6,
      orderAspek: 6,
      value: 'Adaptif',
      indikator: [
        {
          id: 16,
          orderIndikator: 1,
          value:
            'Menyesuaikan diri secara cepat dalam menghadapi dinamika pendidikan',
          ekspektasi: [
            {
              id: 44,
              orderEkspektasi: 1,
              value: 'Menyesuaikan diri di berbagai lingkungan kerja',
            },
            {
              id: 45,
              orderEkspektasi: 2,
              value: 'Beradaptasi dengan dinamika perubahan lingkungan',
            },
            {
              id: 46,
              orderEkspektasi: 3,
              value: 'Menguasai dinamika perkembangan teknologi',
            },
          ],
        },
        {
          id: 17,
          orderIndikator: 2,
          value:
            'Terus berinovasi dan mengembangkan kreativitas untuk memajukan pendidikan',
          ekspektasi: [
            {
              id: 47,
              orderEkspektasi: 1,
              value:
                'Menyampaikan ide dan gagasan dengan berani untuk kemajuan satuan pendidikan',
            },
            {
              id: 48,
              orderEkspektasi: 2,
              value:
                'Membuat inovasi yang mendukung transformasi pendidikan secara konsisten',
            },
            {
              id: 49,
              orderEkspektasi: 3,
              value:
                'Mengantisipasi permasalahan yang terjadi di satuan pendidikan dengan kritis',
            },
            {
              id: 50,
              orderEkspektasi: 4,
              value: 'Menjalankan sistem kerja berbasis teknologi informasi',
            },
          ],
        },
        {
          id: 18,
          orderIndikator: 3,
          value: 'Berpikir proaktif untuk memajukan satuan pendidikan',
          ekspektasi: [
            {
              id: 51,
              orderEkspektasi: 1,
              value: 'Mengidentifikasi potensi masalah dan solusinya',
            },
            {
              id: 52,
              orderEkspektasi: 2,
              value: 'Menunjukkan keingintahuan yang tinggi terhadap hal baru',
            },
            {
              id: 53,
              orderEkspektasi: 3,
              value:
                'Memanfaatkan peluang untuk menghasilkan hal yang lebih baik',
            },
          ],
        },
      ],
    },
    {
      id: 7,
      orderAspek: 7,
      value: 'Kolaboratif',
      indikator: [
        {
          id: 19,
          orderIndikator: 1,
          value:
            'Memberi kesempatan bagi satuan pendidikan dan masyarakat untuk berkontribusi dalam peningkatan kualitas pembelajaran',
          ekspektasi: [
            {
              id: 54,
              orderEkspektasi: 1,
              value:
                'Menerima pendapat dan saran secara terbuka untuk perbaikan hasil kerja',
            },
            {
              id: 55,
              orderEkspektasi: 2,
              value: 'Memuji keunggulan dan prestasi orang lain',
            },
            {
              id: 56,
              orderEkspektasi: 3,
              value: 'Membagi tugas dan tanggung jawab secara proporsional',
            },
          ],
        },
        {
          id: 20,
          orderIndikator: 2,
          value:
            'Mampu bekerja sama dengan satuan pendidikan dan masyarakat untuk meningkatkan kualitas layanan satuan pendidikan',
          ekspektasi: [
            {
              id: 57,
              orderEkspektasi: 1,
              value:
                'Mengajukan diri secara sukarela untuk terlibat dalam kegiatan yang mendukung transformasi pendidikan',
            },
            {
              id: 58,
              orderEkspektasi: 2,
              value:
                'Bersinergi dengan berbagai pihak dalam mendorong transformasi pendidikan',
            },
            {
              id: 59,
              orderEkspektasi: 3,
              value:
                'Mengakui ketika berbuat kesalahan dan berkomitmen tidak mengulanginya',
            },
          ],
        },
        {
          id: 21,
          orderIndikator: 3,
          value:
            'Menggerakkan pemanfaatan sumber daya dinas pendidikan, satuan pendidikan, dan masyarakat untuk pencapaian transformasi pendidikan',
          ekspektasi: [
            {
              id: 60,
              orderEkspektasi: 1,
              value:
                'Mendorong satuan pendidikan dan masyarakat untuk terlibat aktif dalam pencapaian tujuan satuan pendidikan',
            },
            {
              id: 61,
              orderEkspektasi: 2,
              value:
                'Membangun komunikasi yang efektif dalam berkoordinasi dengan dinas pendidikan, satuan pendidikan, dan masyarakat',
            },
            {
              id: 62,
              orderEkspektasi: 3,
              value:
                'Mengoptimalkan sumber daya yang mendukung transformasi pendidikan yang berdampak pada peserta didik',
            },
          ],
        },
      ],
    },
  ],
}
